import React, { useEffect, useState } from 'react'
import Proptypes from 'prop-types'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { Modal, Button, Form } from 'semantic-ui-react'
import Swal from 'sweetalert2'
import { primaryColor } from '../../../../constants'
import IntelMsg from '../../../ItelMsg/index'
import { UpdateAssetLabel, DeleteHierarchy } from '../../../../services/asset'

const specialChar = /^[A-Za-z0-9ء-ي ]+$/

const formValidator = {
  label: yup
    .string()
    .trim()
    .required('Name Is Required')
    .matches(specialChar, 'Name has invalid characters'),
}

const SiteActionsModal = (props) => {
  console.log('level: ', props.level)
  const [action, setSelectedAction] = useState('Edit')
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })
  const [open, setOpen] = useState(false)
  useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  useEffect(() => {
    props.getState(open)
  }, [open])

  const onSubmit = async (data) => {
    const queryParams = {
      customerId: props.level.customerId,
      label: data.label,
    }
    Swal.showLoading()
    const res = await UpdateAssetLabel(queryParams, props.level.id)
    if (res.success) {
      await Swal.fire('Label Updated Successfully', '', 'success')
      setOpen(false)
    } else {
      console.log('error', res)
      Swal.fire(res.msg || 'Error Updating label', '', 'error')
    }
  }

  const editForm = (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group>
        <Form.Field required>
          <strong>Label</strong>
          <input placeholder="Enter new label" ref={register} name="label" />
          <small style={{ color: 'red' }}>
            <IntelMsg id={['**']} />
          </small>
          {errors.label && (
            <p style={{ color: 'red' }}>{errors.label.message}</p>
          )}
        </Form.Field>
      </Form.Group>
      <Button type="submit">Submit</Button>
    </Form>
  )

  const handleDelete = async () => {
    Swal.showLoading()
    const queryParams = {
      levelType: props.level.levelType,
    }
    const res = await DeleteHierarchy(queryParams, props.level.id)
    if (res.success) {
      await Swal.fire('Level Deleted Successfully', '', 'success')
      setSelectedAction('Edit')
      setOpen(false)
    } else {
      Swal.fire(res.msg || 'Error Deleting Level', '', 'error')
    }
  }

  const deleteForm = (
    <>
      <h3>Are you sure you want to delete this level</h3>
      <Button
        style={{ backgroundColor: 'red', color: 'white' }}
        onClick={handleDelete}
      >
        Yes
      </Button>
    </>
  )

  const handleClose = () => {
    setSelectedAction('Edit')
    setOpen(false)
  }
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        style={{ width: '450px' }}
      >
        <Modal.Header style={{ backgroundColor: '#303D54', color: '#FFF' }}>
          Choose Action on {props.level.label || props.level.name}
        </Modal.Header>
        <Modal.Content>
          <select
            style={{
              padding: '5px',
              width: '200px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              outline: 'none',
              marginBottom: '18px',
            }}
            onChange={(e) => setSelectedAction(e.target.value)}
          >
            <option value="Edit">Edit</option>
            <option value="Delete">Delete</option>
          </select>
          {action === 'Edit' && editForm}
          {action === 'Delete' && deleteForm}
        </Modal.Content>
        <Modal.Actions>
          <Button
            style={{ backgroundColor: primaryColor, color: 'white' }}
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

SiteActionsModal.propTypes = {
  open: Proptypes.bool,
  getState: Proptypes.func,
  level: Proptypes.object,
}

export default SiteActionsModal
